__webpack_require__.p = "https://voicetyping.xyz/";